import { render, staticRenderFns } from "./page-wrapper.vue?vue&type=template&id=18a46f16"
import script from "./page-wrapper.vue?vue&type=script&lang=ts"
export * from "./page-wrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a46f16')) {
      api.createRecord('18a46f16', component.options)
    } else {
      api.reload('18a46f16', component.options)
    }
    module.hot.accept("./page-wrapper.vue?vue&type=template&id=18a46f16", function () {
      api.rerender('18a46f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/page-wrapper.vue"
export default component.exports